module.exports = __webpack_public_path__ + "static/img/ls.4e82463d.svg";